import { CustomModal } from "../Modal";

export const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "danger",
  isLoading = false,
}) => {
  return (
    <CustomModal
      title={title}
      open={isOpen}
      close={onClose}
      showPrimaryButton
      primaryButtonText={confirmText}
      primaryButtonClick={onConfirm}
      primaryButtonColor={confirmColor}
      primaryButtonLoading={isLoading}
      primaryButtonDisabled={isLoading}
      showSecondaryButton
      secondaryButtonText={cancelText}
      secondaryButtonClick={onClose}
      secondaryButtonDisabled={isLoading}
      isDismissable={!isLoading}
    >
      <p className="text-sm text-darkgrey">{message}</p>
    </CustomModal>
  );
};
